import axios from 'axios';

const API_URL = '/api/artworks.json';

export const fetchAllArtworks = async () => {
    try {
        const response = await axios.get(`${API_URL}?t=${new Date().getTime()}`);
        return response.data;
    } catch (error) {
        throw new Error('Error fetching artworks');
    }
};

export const fetchArtworkById = async (id: string) => {
    try {
        const response = await axios.get(`${API_URL}?t=${new Date().getTime()}`);
        const artworks = response.data;
        // In een statische omgeving zoeken we het artwork in de JSON lijst
        // We vergelijken op title of we gebruiken de id als we die hebben
        return artworks.find((a: any) => a._id === id || a.title === id);
    } catch (error) {
        console.error(`Error fetching artwork with id ${id}:`, error);
        throw error;
    }
};